import SelectHotPanelModel from './src/index';

export default SelectHotPanelModel;
